var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"login-input",staticStyle:{"margin":"20px"},on:{"click":function($event){return _vm.onSynchro()}}},[_vm._v("同步")])}
var staticRenderFns = []

export { render, staticRenderFns }